// components/TopBar.js
import React from 'react';
import { Box, Container, Typography, IconButton } from '@mui/material';
import { Phone, Email, Twitter, Facebook, Instagram } from '@mui/icons-material';

const TopBar = () => {
  return (
    <Box sx={{ 
      bgcolor: 'primary.dark', 
      color: 'white', 
      py: 1,
      background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
      borderBottom: '1px solid rgba(255,255,255,0.1)',
      boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
    }}>
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          flexWrap: 'wrap'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              padding: '4px 12px',
              borderRadius: '20px',
              background: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)'
            }}>
              <Phone fontSize="small" sx={{ fontSize: '16px' }} />
              <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                +234 8065514429
              </Typography>
            </Box>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              padding: '4px 12px',
              borderRadius: '20px',
              background: 'rgba(255,255,255,0.1)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.2)'
            }}>
              <Email fontSize="small" sx={{ fontSize: '16px' }} />
              <Typography variant="body2" sx={{ fontSize: '0.8rem', fontWeight: 500 }}>
                info@grandluxe.com
              </Typography>
            </Box>
          </Box>
          
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1 
          }}>
            <IconButton
              size="small"
              sx={{
                color: 'white',
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '8px',
                padding: '6px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  background: 'rgba(255,255,255,0.2)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }
              }}
            >
              <Twitter sx={{ fontSize: '18px' }} />
            </IconButton>
            
            <IconButton
              size="small"
              sx={{
                color: 'white',
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '8px',
                padding: '6px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  background: 'rgba(255,255,255,0.2)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }
              }}
            >
              <Facebook sx={{ fontSize: '18px' }} />
            </IconButton>
            
            <IconButton
              size="small"
              sx={{
                color: 'white',
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '8px',
                padding: '6px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  background: 'rgba(255,255,255,0.2)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                }
              }}
            >
              <Instagram sx={{ fontSize: '18px' }} />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default TopBar;